import { useState, type FC, type SyntheticEvent } from 'react';
import FullScreenImageSlider from '../../../components/images/FullScreenImageSlider';
import { LocationEvent } from '../../../domain/models/locations/LocationEvent';
import { ReactComponent as TrainIcon } from '../../../icons/train.svg';
import { ReactComponent as CloseIcon } from '../../../icons/xmark.svg';
import EventHeader from '../../../presentation/components/event-detail/EventHeader';

const station_background_light_image = '/assets/icons/offlineLocation/station_background.png';
const station_background_dark_image = '/assets/icons/offlineLocation/station_background_b.png';

interface EventPosterProps {
  eventDetail: LocationEvent;
  onClosed?: () => void;
}

const EventPoster: FC<EventPosterProps> = ({ eventDetail, onClosed }) => {
  const [isOpenImageSlider, setIsOpenImageSlider] = useState(false);
  const [imageOrientation, setImageOrientation] = useState<'landscape' | 'portrait'>('landscape');

  // 이미지 로드 시 가로/세로 확인
  const handleImageLoad = (event: SyntheticEvent<HTMLImageElement>) => {
    const img = event.currentTarget;
    const isLandscape = img.naturalWidth > img.naturalHeight;
    setImageOrientation(isLandscape ? 'landscape' : 'portrait');
  };

  switch (eventDetail.category) {
    case 'billboard_ad':
      return (
        <div>
          <div className="relative">
            <div className="w-full">
              <img
                src={station_background_light_image}
                alt="station_background_image"
                className="w-full dark:hidden"
              />
              <img
                src={station_background_dark_image}
                alt="station_background_image"
                className="w-full hidden dark:block"
              />
            </div>
            <div className="absolute bottom-0 left-0 z-[2]">
              <EventHeader eventDetail={eventDetail} />
            </div>
            <div className="absolute bottom-0 left-0 bg-[linear-gradient(to_top,rgba(255,255,255,1)_75%,rgba(255,255,255,0)100%)] dark:bg-[linear-gradient(to_top,rgba(13,14,18,1)_50%,rgba(13,14,18,0)100%)] h-[171px] w-full z-[1]" />
            <div className="absolute top-0 left-0 w-full">
              <div
                className="absolute top-0 left-0 rounded-full mt-[16px] mb-[16px] mx-[16px] bg-placeholder-light w-[32px] h-[32px] flex items-center justify-center z-[20] cursor-pointer"
                onClick={() => onClosed?.()}
              >
                <CloseIcon className="fill-pure-white w-[20px] h-[20px]" />
              </div>
              <div className={imageOrientation === 'portrait' ? 'p-4' : ''}>
                <div
                  className={`rounded-none mt-7 py-5 ${
                    imageOrientation === 'portrait' ? 'px-[27px]' : ''
                  }`}
                >
                  <div className="relative filter drop-shadow-[0px_3px_4px_rgba(0,0,0,0.10)]">
                    <div className="absolute left-1/2 -translate-x-1/2 w-screen top-1/2 -translate-y-1/2 h-[18px] bg-main-light-2 dark:bg-sub-dark-2" />
                    <div className="relative flex items-center justify-center z-10 bg-white rounded-[50px] px-[16px] py-[9px] border-[7px] border-main-light-2 dark:border-sub-dark-2 w-fit mx-auto">
                      <div className="flex items-center mr-2">
                        <div className="w-8 h-8 rounded-full bg-main-light-2 flex items-center justify-center">
                          <TrainIcon className="w-[19px] h-[19px] fill-white" />
                        </div>
                      </div>
                      <div className="flex flex-col gap-0.5">
                        <div className="text-[13px] font-semibold text-main-light-1">
                          {eventDetail.location.name}
                        </div>
                        <div className="text-[11px] text-main-light-3">
                          {eventDetail.location.description}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-7">
                    {imageOrientation === 'landscape' ? (
                      <div
                        className="overflow-x-auto"
                        style={{ marginTop: '63px', marginBottom: '63px' }}
                      >
                        <div className="min-w-[873px]">
                          <img
                            src={eventDetail.baseImageUrl}
                            alt="event_image"
                            className="w-[873px] h-[352px] p-[11px] bg-pure-white shadow-[0px_2px_10px_0px_rgba(0,0,0,0.12)] object-cover"
                            style={{
                              border: '11px solid pure-white',
                              boxSizing: 'border-box'
                            }}
                            onLoad={handleImageLoad}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="w-full">
                        <img
                          src={eventDetail.baseImageUrl}
                          alt="event_image"
                          className="w-full p-[11px] bg-pure-white shadow-[0px_2px_10px_0px_rgba(0,0,0,0.12)]"
                          style={{
                            border: '11px solid pure-white',
                            boxSizing: 'border-box'
                          }}
                          onLoad={handleImageLoad}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    default:
      return (
        <div>
          <div
            className="absolute top-0 left-0 rounded-full mt-[calc(env(safe-area-inset-top)+16px)] mb-[16px] mx-[16px] bg-placeholder-light dark:bg-secondary-dark w-[32px] h-[32px] flex items-center justify-center z-[20] cursor-pointer"
            onClick={() => onClosed?.()}
          >
            <CloseIcon className="fill-pure-white  w-[20px] h-[20px]" />
          </div>
          <img
            src={eventDetail.baseImageUrl}
            alt="event_image"
            className="w-full"
            onClick={() => setIsOpenImageSlider(true)}
          />

          {isOpenImageSlider && (
            <FullScreenImageSlider
              isOpen={isOpenImageSlider}
              imageUrls={eventDetail.posterImageUrls}
              onClosed={() => setIsOpenImageSlider(false)}
            />
          )}
        </div>
      );
  }
};

export default EventPoster;





